import React from "react"

function InnerHtml(props) {
  return (
    <div className={props.className} dangerouslySetInnerHTML={{__html: props.html}} />
    )
}

export default InnerHtml